import EventPage from "./event_page";
import { Calendar } from "@fullcalendar/core";
import momentTimezonePlugin from "../modules/moment_timezone_plugin";
import listPlugin from "@fullcalendar/list";
import { initializeModals } from "../modules/utils";

class EventList extends EventPage {
  constructor(node) {
    super(node);
    this.eventListElement = this.element.querySelector(".js-event-list");
    this.eventTemplateElement = this.element.querySelector(".js-event-template");
    this.calendarDefaultOptions.titleRangeSeparator = ` ${this.eventListElement.dataset.rangeSeparator} `;
    this.calendarDefaultOptions.buttonText = {
      today: this.eventListElement.dataset.todayText,
    };

    this.allDayText = this.element.dataset.allDayText;

    this.prepare();
  }

  initialize() {
    super.initialize();

    this.calendar = new Calendar(this.eventListElement, {
      ...this.calendarDefaultOptions,
      locale: this.fullLocale,
      plugins: [listPlugin, momentTimezonePlugin],
      initialView: "listWeek",
      initialDate: this.startDate,
      eventDisplay: "block",
      events: this.events,
      listDayFormat: function (date) {
        let formattedDate = new Intl.DateTimeFormat(this.fullLocale, {
          day: "numeric",
          month: "short",
          weekday: "short",
        });
        const parts = formattedDate.formatToParts(date.start.marker);
        return `${parts[0].value}, ${parts[2].value} ${parts[4].value}`;
      },
      listDaySideFormat: () => {
        return "";
      },
      eventClick: function (args) {
        let clickedLinkElement;
        if (args.jsEvent.target.tagName.toLowerCase() === "a") {
          clickedLinkElement = args.jsEvent.target;
        } else {
          clickedLinkElement = args.jsEvent.target.closest("a");
        }
        if (!clickedLinkElement || !clickedLinkElement.hasAttribute("data-js")) {
          args.jsEvent.preventDefault();
        }
      },
      eventContent: (args) => {
        return this.markEventWithId(args.event);
      },
      eventsSet: (eventSet) => {
        if (this.events.length == eventSet.length) {
          const tableElement = this.eventListElement.querySelector("table.fc-list-table");
          if (tableElement) {
            this.transformEvents(tableElement, eventSet);
          }
        }
      },
      datesSet: (args) => {
        this.agendaWrapper.classList.add("is-loading");
        clearTimeout(this.dateSetTimeOut);

        this.handleNewDateSet(args);
      },
    });

    // Event List
    this.calendar.render();
    this.eventListTimeZoneButton = this.eventListElement.querySelector(".fc-timeZoneButton-button");
    this.eventListTimeZoneButton.innerHTML = `GMT ${this.selectedGmtOffset}`;

    this.addTimeZoneSelect();
  }

  airDatepickerOnSelect(date) {
    this.calendar.gotoDate(date);
  }

  removeAllEvents() {
    this.calendar.removeAllEvents();
  }

  addEvents() {
    this.calendar.removeAllEvents();
    this.events.forEach((event) => {
      this.calendar.addEvent(event);
    });
  }

  updateCalendarTimezone() {
    const gmt = this.getGmtOffset(this.selectedTimeZone);
    this.eventListTimeZoneButton.innerHTML = `GMT ${gmt}`;
  }

  transformEvents(tableElement, eventSet) {
    let eventStartElement = document.createElement("td");
    if (tableElement.querySelectorAll("tr").length > 0) {
      tableElement.querySelectorAll("tr").forEach((row) => {
        if (row.classList.contains("fc-list-day")) {
          if (row.nextElementSibling && row.nextElementSibling.classList.contains("fc-event")) {
            let dayElement = row.querySelector("div.fc-list-day-cushion");
            eventStartElement = null;
            eventStartElement = document.createElement("div");
            if (dayElement) {
              eventStartElement.appendChild(dayElement.cloneNode(true));
            }
          }
        } else if (row.classList.contains("fc-event")) {
          const eventIdElement = row.querySelector(".event-id");
          const id = eventIdElement.dataset.id;
          const event = eventSet.find((event) => event._def.defId == id);

          row.dataset.js = "ajax-modal";
          row.href = event.url;
          row.dataset.errorMessage = this.element.dataset.modalErrorMessage;
          row.innerHTML = ""; // We need to clear the row before appending the new content.
          row.appendChild(this.createFormattedEvent(event, eventStartElement));

          if (eventStartElement.hasChildNodes()) {
            eventStartElement = document.createElement("td");
          }
        }
      });
    }
    initializeModals(this.eventListElement);
  }

  createFormattedEvent(event, eventStartElement) {
    const formattedEvent = document.importNode(this.eventTemplateElement.content, true);
    const options = {
      hour: "numeric",
      minute: "2-digit",
      hour12: false,
      timeZone: this.selectedTimeZone,
    };

    if (eventStartElement) {
      formattedEvent.querySelector(".date").appendChild(eventStartElement);
    }

    if (event.allDay) {
      formattedEvent.querySelector(".time").textContent = this.allDayText;
    } else {
      const startTime = event.start.toLocaleTimeString(this.fullLocale, options);
      const endTime = event.end.toLocaleTimeString(this.fullLocale, options);

      formattedEvent.querySelector(".time").textContent = `${startTime} - ${endTime}`;
    }

    formattedEvent.querySelector(".event-type").textContent = event.extendedProps.eventType;
    formattedEvent.querySelector(".description").textContent = event.extendedProps.description;

    const actionLink = formattedEvent.querySelector(".action a");
    actionLink.href = event.url;
    return formattedEvent;
  }

  markEventWithId(event) {
    const html = `<div class="event-id" data-id="${event._def.defId}"></div>`;
    return { html: html };
  }

  findPreviousSiblingWithClass(element, className) {
    var sibling = element.previousElementSibling;

    while (sibling) {
      if (sibling.classList.contains(className)) {
        return sibling;
      }

      sibling = sibling.previousElementSibling;
    }

    return null;
  }
}

const eventListElement = document.querySelector('[data-js="event-list"]');
if (eventListElement) {
  new EventList(eventListElement);
}
